import React, { useEffect, useState } from 'react';
import Datatable from '../../components/Datatable';
import FormDialog, { Text } from '../../components/Datatable/FormDialog';
import {
    Box, Button, IconButton, Snackbar, TextField, Tooltip, Typography, setRef,
    Dialog, DialogTitle, DialogContent, DialogActions,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { create, get_one, update, delete_one } from '../../services/api';
import { isValidDomainFormatRfcCompliant, isGovernmentDomain, isEssentialDomain, normalizeDomain } from '../../utils/domainFilter';
import { handleQueuedResponse } from '../../utils/handleQueuedResponse';
import EditIcon from '@mui/icons-material/Edit';
import { useNotify } from '../../components/Datatable/NotifyProvider';
import { useFormError } from '../../components/Datatable/FormErrorProvider';
import { RemoveCircleOutline } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { useAuth } from '../../components/AuthProvider';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { red, green } from '@mui/material/colors';
import KeyIcon from '@mui/icons-material/Key';
import CircularProgress from '@mui/material/CircularProgress';
import api from '../../services/api';
import Backdrop from '@mui/material/Backdrop';
import SyncIcon from '@mui/icons-material/Sync';
import { useLoading } from '../../components/LoadingProvider';
import Swal from 'sweetalert2';

export default function Node() {
    const notify = useNotify()
    const auth = useAuth()
    const loading = useLoading()
    const { isLoading, setLoading } = loading
    const [formState, setFormState] = useState({
        open: false,
        id: null,
    })
    const [refresh, setRefresh] = useState(false)
    React.useEffect(() => {
        document.title = "IPV7 Tools - DNS Zona Local"
    }, [])
    return (
        <>
            <FormItem
                open={formState.open}
                id={formState.id}
                handlerClose={() => setFormState({ open: false, id: null })}
                handlerSubmit={() => setRefresh(true)}
                btnSubmit={formState.id ? 'Atualizar' : 'Salvar'}
                btnClose={'Fechar'}
            ></FormItem>
            <Datatable
                refresh={refresh}
                handlerRefresh={() => setRefresh(!refresh)}
                title='Zona Local'
                endpoint='/dns/localzone'
                options={{
                    customToolbar: () =>
                        <>
                            <Tooltip title="Remover todos os filtros">
                                <IconButton onClick={() => { localStorage.removeItem("datatable" + "'/dns/local_zone"); location.reload() }} >
                                    <RemoveCircleOutline />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Adicionar">
                                <IconButton disabled={!auth.hasPerm("dns_localzone.create")}
                                    onClick={() => setFormState({ open: true, id: null })}
                                >
                                    <AddIcon />
                                </IconButton>
                            </Tooltip>
                        </>
                    ,
                    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => ""
                }
                }
                columns={[
                    {
                        name: 'id',
                        label: 'ID',
                        options: {
                            display: false
                        }
                    },
                    {
                        name: 'domain',
                        label: 'Domínio',
                    },
                    {
                        name: 'ip',
                        label: 'IP',
                    },
                    {
                        name: 'actions',
                        label: 'Ações',
                        options: {
                            filter: false,
                            sort: false,
                            customBodyRender: (value, tableMeta, updateValue) => {
                                const id = tableMeta.rowData[0]
                                return (
                                    <>
                                        <IconButton
                            disabled={!auth.hasPerm("dns_localzone.delete")}
                            onClick={() => {
                                Swal.fire({
                                    title: 'Excluir zona local?',
                                    text: 'Deseja excluir esta zona DNS local?',
                                    icon: 'warning',
                                    showCancelButton: true,
                                    confirmButtonText: 'Sim, excluir',
                                    cancelButtonText: 'Cancelar',
                                    confirmButtonColor: '#e01b29',
                                }).then((result) => {
                                    if (!result.isConfirmed) return
                                    setLoading(true)
                                    api.delete(`dns/localzone/${id}`).then(res => {
                                        handleQueuedResponse(res, notify, {
                                            successMessage: 'Zona local removida — sync DNS na fila',
                                        })
                                    }).catch(e => {
                                        notify.setNotify({ open: true, message: e.response?.data?.detail || e.message, severity: 'error' })
                                    }).finally(() => {
                                        setRefresh(true)
                                        setLoading(false)
                                    })
                                });
                            }}>
                            <DeleteIcon />
                        </IconButton>
                                    </>
                                )
                            }
                        }
                    }
                ]}

            />
        </>
    )
}




function FormItem({ id, open, handlerClose, handlerSubmit, btnClose = 'Fechar', btnSubmit = 'Salvar' }) {
    const notify = useNotify()
    const error = useFormError()
    const auth = useAuth()
    const loading = useLoading()
    const { isLoading, setLoading } = loading
    const [blockDialog, setBlockDialog] = useState({ open: false, reason: '', domain: '' })
    const [essentialDialog, setEssentialDialog] = useState({ open: false, domain: '' })

    useEffect(() => {
        if (open){

            setState({
                ip: '',
                domain: '',
            })
            error.setErrors([])
        }
    },[open])


    const [state, setState] = useState({
        ip: '',
        domain: '',

    })
    const handleChange = (event) => {
        setState({ ...state, [event.target.name]: event.target.value });
    }

    const wrapperSubmit = () => {
        const normalized = normalizeDomain(state.domain || '')
        if (!isValidDomainFormatRfcCompliant(normalized)) {
            setBlockDialog({ open: true, reason: 'invalid', domain: state.domain })
            return
        }
        if (isGovernmentDomain(normalized)) {
            setBlockDialog({ open: true, reason: 'government', domain: normalized })
            return
        }
        if (isEssentialDomain(normalized)) {
            setEssentialDialog({ open: true, domain: normalized })
            return
        }
        doSubmit()
    }

    const doSubmit = () => {
        setLoading(true)
        create('/dns/localzone/create', state)
                .then(res => {
                    if (res.data?.errors) {
                        error.setErrors(res.data.errors)
                        return
                    }
                    const r = handleQueuedResponse(res, notify, {
                        successMessage: 'Zona local criada — sync DNS na fila',
                    })
                    if (r.ok) {
                        error.setErrors([])
                        handlerClose()
                        return
                    }
                })
                .catch(e =>
                    notify.setNotify({ open: true, message: e.message, severity: 'error' }))
                    .finally(()=>{
                        handlerSubmit()
                        setLoading(false)
                        handlerClose()
                })


    }
    return (
        <Box component={"form"}
            onSubmit={wrapperSubmit}
            sx={{ m: 2 }}
            display={'flex'}
            flexWrap={'wrap'}
        >

            <FormDialog
                title={
                    <Box display={"flex"} justifyContent={'space-between'}>
                        <Typography variant="h6" component="div">{id ? 'Editar' : 'Adicionar'} Zona Local</Typography>
                        
                    </Box>
                }
                open={open}
                handlerSubmit={wrapperSubmit}
                handlerClose={handlerClose}
                btnSubmit={btnSubmit}
                btnClose={btnClose}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>

                    <TextField
                        sx={{ mb: 2, mt: 1}}
                        error={error.verify("domain")}
                        helperText={error.msgError("domain")}
                        label='Domínio'
                        name={"domain"}
                        value={state.domain}
                        onChange={handleChange}
                    />
                    <TextField
                        sx={{ mb: 2}}
                        error={error.verify('ip')}
                        helperText={error.msgError('ip')}
                        label='IP'
                        value={state.ip}
                        name={'ip'}
                        onChange={handleChange}
                    />
                   


                </Box>

            </FormDialog>

            <Dialog
                open={blockDialog.open}
                onClose={() => setBlockDialog({ open: false, reason: '', domain: '' })}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <WarningAmberIcon color="warning" />
                    Domínio não permitido
                </DialogTitle>
                <DialogContent>
                    {blockDialog.reason === 'government' ? (
                        <Typography variant="body2">
                            <strong>{blockDialog.domain}</strong> é um domínio governamental brasileiro
                            (.gov.br/.mil.br/.leg.br/.jus.br ou órgão público) e não pode ser cadastrado
                            como zona local.
                        </Typography>
                    ) : (
                        <Typography variant="body2">
                            <strong>{blockDialog.domain || '(vazio)'}</strong> não é um formato de domínio
                            válido (RFC 1035/1123). Verifique se há espaços, pontos duplicados ou caracteres
                            não permitidos.
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setBlockDialog({ open: false, reason: '', domain: '' })}>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={essentialDialog.open}
                onClose={() => setEssentialDialog({ open: false, domain: '' })}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#b26a00' }}>
                    <WarningAmberIcon color="warning" />
                    Domínio amplamente utilizado
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body2">
                        <strong>{essentialDialog.domain}</strong> está na lista de domínios
                        amplamente utilizados. Cadastrar uma zona local pra esse domínio pode
                        impactar usuários da rede.
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 1.5 }}>
                        Tem certeza que deseja continuar?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setEssentialDialog({ open: false, domain: '' })}>
                        Cancelar
                    </Button>
                    <Button
                        variant="contained"
                        color="warning"
                        onClick={() => {
                            setEssentialDialog({ open: false, domain: '' })
                            doSubmit()
                        }}
                    >
                        Continuar
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}


